import { render, staticRenderFns } from "./EngagementDetails.vue?vue&type=template&id=4a1cfe7d&scoped=true&"
import script from "./EngagementDetails.vue?vue&type=script&lang=js&"
export * from "./EngagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./EngagementDetails.vue?vue&type=style&index=0&id=4a1cfe7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1cfe7d",
  null
  
)

export default component.exports